module.exports = __webpack_public_path__ + "img/5.9b160ef8.png";